export default "__VITE_ASSET__BEXrT2oI__"